"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CausalHistoryDelta = void 0;
const CausalHistoryFragment_1 = require("./CausalHistoryFragment");
class CausalHistoryDelta {
    constructor(mutableObj, store) {
        this.mutableObj = mutableObj;
        this.store = store;
        this.fragment = new CausalHistoryFragment_1.CausalHistoryFragment(mutableObj);
        this.start = new CausalHistoryFragment_1.CausalHistoryFragment(mutableObj);
        this.gap = new Set();
    }
    async compute(targetOpHistories, startingOpHistories, maxDeltaSize, maxBacktrackSize) {
        var _a, _b, _c;
        for (const hash of startingOpHistories) {
            const opHistory = await this.store.loadOpCausalHistoryByHash(hash);
            if (opHistory !== undefined) {
                this.start.add(opHistory);
                this.fragment.remove(opHistory.causalHistoryHash);
            }
        }
        for (const hash of targetOpHistories) {
            if (!this.start.contents.has(hash)) {
                const opHistory = await this.store.loadOpCausalHistoryByHash(hash);
                if (opHistory !== undefined) {
                    this.fragment.add(opHistory);
                }
            }
        }
        this.updateGap();
        while (this.gap.size > 0 && this.fragment.contents.size < maxDeltaSize) {
            let h = undefined;
            for (const hash of this.fragment.getStartingOpHistories()) {
                const op = this.fragment.contents.get(hash);
                if (h === undefined || ((_a = op._computedProps) === null || _a === void 0 ? void 0 : _a.height) < h) {
                    h = (_b = op._computedProps) === null || _b === void 0 ? void 0 : _b.height;
                }
            }
            for (const hash of Array.from(this.start.missingPrevOpHistories)) {
                if (this.start.contents.size >= maxBacktrackSize) {
                    break;
                }
                const op = await this.store.loadOpCausalHistoryByHash(hash);
                if (op !== undefined && ((_c = op._computedProps) === null || _c === void 0 ? void 0 : _c.height) > h) {
                    this.start.add(op);
                    this.fragment.remove(hash);
                }
            }
            for (const hash of Array.from(this.fragment.missingPrevOpHistories)) {
                if (this.fragment.contents.size >= maxDeltaSize) {
                    break;
                }
                if (!this.start.contents.has(hash)) {
                    const op = await this.store.loadOpCausalHistoryByHash(hash);
                    if (op !== undefined) {
                        this.fragment.add(op);
                    }
                }
            }
            this.updateGap();
        }
    }
    opHistoriesFollowingFromStart(maxOps) {
        const start = new Set(this.start.contents.keys());
        return this.fragment.causalClosure(start, maxOps);
    }
    updateGap() {
        const gap = new Set();
        for (const hash of this.fragment.missingPrevOpHistories) {
            if (!this.start.contents.has(hash)) {
                gap.add(hash);
            }
        }
        this.gap = gap;
    }
}
exports.CausalHistoryDelta = CausalHistoryDelta;
//# sourceMappingURL=CausalHistoryDelta.js.map